
import { Vue, Component, Prop } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import Ace from "@/components/helpers/ace.vue";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import MetaData from "./product-class-param-item.json";
import InlineFileUploader from "@/components/inline-file-uploader.vue";
@Component({
  components: { InlineFileUploader, Ace },
})
export default class editorSelectorExtends extends Vue {
  @Prop() param!: any;
  visible: boolean = false;
  json: string = "";
  editors = [
    {
      name: "string",
      caption: "Текстовое поле",
    },
    {
      name: "number",
      caption: "Числовое поле",
      min: 0,
      max: 100,
    },
    {
      name: "boolean",
      caption: "Чекбокс",
    },
    {
      name: "enum",
      caption: "Выбор одного элемента из списка",
      mode: "radio",
      labelKeyName: "caption",
      valueKeyName: "value",
      items: [
        {
          caption: "",
          value: 0,
        },
      ],
    },
    {
      name: "color",
      caption: "Цвет",
      mode: "single",
      colorKeyName: "color",
      labelKeyName: "caption",
      valueKeyName: "value",
      items: [
        {
          caption: "Белый",
          color: "#fff",
          value: "white",
        },
      ],
    },
    {
      name: "array",
      caption: "Выбор нескольких элементов из списка",
      valueKeyName: "value",
      labelKeyName: "caption",
      items: [
        {
          caption: "",
          value: 0,
        },
      ],
    },
  ];

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: this.param.id,
    className: "productClassParam",
    config: {},
    model: this.param,
  });

  paramItemDataSource: ListDataSource = new ListDataSource({
    className: "productclassparamitem",
    config: {},
  });

  updateColor(id: number, event: string) {
    const items = this.paramItemDataSource.getMetaDataByName("value").items;
    const item = items.find((i: any) => i.color == event);
    if (!item) return;
    this.paramItemDataSource.updateField(id, [
      {
        fieldName: "value",
        fieldValue: item.color,
      },
      {
        fieldName: "caption",
        fieldValue: item.caption,
      },
    ]);
    this.$message("Значение успешно сохранено");
  }

  get showItems() {
    return !["number", "string", "checkbox"].includes(
      this.selectedEditorTypeName
    );
  }

  itemTypes = [
    {
      name: "enum",
      caption: "Выбор 1 элемента из списка",
    },
    {
      name: "array",
      caption: "Выбор нескольких элементов из списка",
    },
    {
      name: "color",
      caption: "Выбор цвета",
    },
    {
      name: "number",
      caption: "Число",
    },
    {
      name: "string",
      caption: "Строка",
    },
    {
      name: "checkbox",
      caption: "Чекбокс",
    },
  ];

  get selectedEditorTypeName(): string {
    const e = this.dataSource.model?.editor;
    if (e == null || e === "") return "";
    const s = String(e).trim();
    if (s.startsWith("{")) {
      try {
        return JSON.parse(s).name ?? "";
      } catch {
        return "";
      }
    }
    return s;
  }

  get colorMode(): string {
    const e = this.dataSource.model?.editor;
    if (e == null || e === "") return "multiple";
    const s = String(e).trim();
    if (s.startsWith("{")) {
      try {
        const m = JSON.parse(s).mode;
        return m === "single" ? "single" : "multiple";
      } catch {
        return "multiple";
      }
    }
    return "multiple";
  }

  async setColorMode(mode: string) {
    this.dataSource.model.editor = JSON.stringify({
      name: "color",
      mode: mode === "single" ? "single" : "multiple",
    });
    this.dataSource.model.editorCaption = "Цвет";
    await this.dataSource.update();
  }

  async updateEditorData(event: any) {
    const item = this.itemTypes.find((i: any) => i.name == event);
    if (!item) return;
    if (item.name === "color") {
      this.dataSource.model.editor = JSON.stringify({
        name: "color",
        mode: "multiple",
      });
    } else {
      this.dataSource.model.editor = item.name;
    }
    this.dataSource.model.editorCaption = item.caption;
    await this.dataSource.update();
  }
  $message: any;

  get editor() {
    const name = this.selectedEditorTypeName;
    if (!name) return null;
    return this.itemTypes.find((i: any) => i.name == name) ?? null;
  }

  isCorrectJson = (json: string) => {
    try {
      JSON.parse(json);
      return true;
    } catch (e) {
      return false;
    }
  };

  async submit() {
    this.visible = false;
  }

  created() {
    this.json = this.dataSource.model.editor;
    this.paramItemDataSource.items = this.dataSource.model.items;
    this.paramItemDataSource.metadata = MetaData;
  }
}
